import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";

const ITEMS = [
  "Renuka Roofing Structurals",
  "Structural Steel Fabrication",
  "Roofing Solutions",
  "Structural Design",
  "Prefabricated Houses",
  "Industrial & Warehouse Structures",
];

export const EditorialMarquee = () => (
  <div data-testid="editorial-marquee" className="border-y border-white/10 bg-[#0A0A0A] py-6 overflow-hidden">
    <Marquee speed={35} gradient={false} pauseOnHover>
      {ITEMS.map((item) => (
        <span key={item} className="mx-8 flex items-center gap-16">
          <span className="font-display text-xl md:text-2xl font-semibold uppercase tracking-wide text-white/85 whitespace-nowrap">
            {item}
          </span>
          <Asterisk size={22} className="text-[#0055FF]" aria-hidden />
        </span>
      ))}
    </Marquee>
  </div>
);
